import { ChevronDown } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { ReactNode } from 'react'

export function ToolCallDetails({ children }: { children: ReactNode }) {
  const { t } = useTranslation()

  return (
    <details className="group mt-4">
      <summary className="flex cursor-pointer list-none items-center gap-2 rounded-sm text-xs font-medium text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring [&::-webkit-details-marker]:hidden">
        <ChevronDown
          className="size-3.5 group-open:rotate-180"
          aria-hidden="true"
        />
        {t('aiChat:toolCallSummary')}
      </summary>
      <ul className="mt-2 space-y-2">{children}</ul>
    </details>
  )
}
